var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    xmlSpace: "preserve",
    viewBox: "476.42 105.44 126.04 102.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F26522",
    d: "M549.2,107.4c-10.7,5.3-33.1,15.5-56.8,20.5c-7.6,1.6-13.5,7.5-14.8,15.2c-1.1,6.2-1.7,14-0.6,22    c1.2,8.9,8.6,15.6,17.6,16.1c13.7,0.8,36.5,4.8,55.2,21.6c5.7,5.1,14.1,6.1,20.9,2.6c8.3-4.2,19-11.2,27.7-22.4    c5-6.5,5.5-15.5,0.8-22.2c-4.4-6.3-9.3-15.9-10.3-28.7c-0.4-4.5-2.2-8.7-5.4-11.8c-4.1-4.1-10.3-9.4-17.6-13    C560.6,104.8,554.4,104.8,549.2,107.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7941E",
    d: "M570.3,181.5c27.7-10.8,1.9-42.2,13.1-61c-4.1-4.1-10.3-9.4-17.6-13c-5.2-2.6-11.4-2.6-16.6,0    c-10.7,5.3-33.1,15.5-56.8,20.5c-1.8,0.4-3.5,1-5,1.8v0c0,0,22.8-4.7,37.6,20.5C539.6,175.4,542.6,192.2,570.3,181.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#E6E7E8",
    cx: 562.5,
    cy: 158,
    r: 11.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#414042",
    cx: 562.5,
    cy: 158,
    r: 7.8
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DE5426",
    d: "M598.4,183.1c2.5-3.2,3.8-7,4-10.8c-8,7.9-22,20.7-32.1,25.2c-14.9,6.7-26.6-12.1-56.1-20.8    c-14.2-4.2-24.9-3.2-32.1-1.1c3.2,3.3,7.6,5.4,12.5,5.6c13.7,0.8,36.5,4.8,55.2,21.6c5.7,5.1,14.1,6.1,20.9,2.6    C579,201.3,589.7,194.3,598.4,183.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHold);
export default __webpack_public_path__ + "static/media/hold.83bf4ddf0bfba2bf78592bca3095eb85.svg";
export { ForwardRef as ReactComponent };